import axiosConfig from 'config/axiosConfig'
import UrlImage from 'config/UrlImage'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'

function DummyList(props) {

    const [listTutorial, setListTutorial] = useState([])
    const [offset, setOffset] = useState(0)
    const [perPage] = useState(2)
    const [pageCount, setPageCount] = useState(0)
    const category_slug = props.match.params.slug

    const getData = async () => {
        const res = await axiosConfig.get(`/api/category-tutorial/${category_slug}`)
        const listTutorial = res.data.list_tutorial.listTutorial

        const slice = listTutorial.slice(offset, offset + perPage)
        console.log(slice);
        const showList = slice.map(item =>
            <div className="col-md-12 col-md-4 col-lg-3" key={item.slug}>
                <div className="card mt-2 mb-2">
                    <div className="card-body">
                        <Link to={`/tutorial/read/${item.slug}`} className="component-content d-block">
                            <div className="content-thumbnail">
                                <div className="content-image">
                                    <Link to={`/tutorial/read/${item.slug}`}>
                                        <img src={`${UrlImage}/${item.image}`} className="img-fluid" />
                                    </Link>
                                </div>
                            </div>
                            <div className="content-title">
                                {item.title}
                            </div>
                        </Link>
                        <div className="divider">
                            <div className="author">
                                <div className="author-profile">
                                    <img
                                        src="#"
                                        className="profile-picture rounded-circle"
                                        alt=""
                                    />
                                    <p className="author-name">Author</p>
                                    <div>
                                        {item.name}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        setListTutorial(showList)
        setPageCount(Math.ceil(listTutorial.length / perPage))
    }

    const handlePageClick = (e) => {
        const selectedPage = e.selectedPage
        setOffset(selectedPage + 1)
    }

    useEffect(() => {
        getData()
    }, [offset, props.match.params.slug])
    return (
        <div className="details-header">
            <div className="container">
                <div className="row mt-4">
                    <h4 className="text-center mt-4">Tutorial : </h4>
                    {listTutorial}
                    <div className="row">
                        <div className="text-center mt-4">
                            <ReactPaginate
                                previousLabel={"<"}
                                nextLabel={">"}
                                breakLabel={"...."}
                                breakClassName={"break-me"}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DummyList
